/**
 * -----------------------------------------------------------------------------
 * Renders the Instagram icon.
 */
export function InstagramIcon() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-gray-950 stroke-2"
        d="
          M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893
          14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711
          9.92893 15.75 12 15.75Z
        "
        strokeMiterlimit="10"
      />
      <path
        className="stroke-gray-950 stroke-2"
        d="
          M16.125 3.375H7.875C5.38972 3.375 3.375 5.38972 3.375 7.875V16.125C3.375
          18.6103 5.38972 20.625 7.875 20.625H16.125C18.6103 20.625 20.625 18.6103
          20.625 16.125V7.875C20.625 5.38972 18.6103 3.375 16.125 3.375Z
        "
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="fill-current"
        d="
          M16.875 8.25C17.4963 8.25 18 7.74632 18 7.125C18 6.50368 17.4963 6
          16.875 6C16.2537 6 15.75 6.50368 15.75 7.125C15.75 7.74632 16.2537
          8.25 16.875 8.25Z
        "
      />
    </svg>
  );
}
